<template>
  <div class="agreement">
    <Header>
      <div slot="rightToolBar" class="bar_content">
        <img src="@/assets/icons/login/close.png" alt="" /><a
          onclick="window.close()"
          >关闭本页</a
        >
      </div>
    </Header>
    <div class="panel">
      <h2 class="title">【奇瑞官方商城】<strong>隐私政策</strong></h2>
      <p class="rigth-text">更新日期：2022年6月27日</p>
      <p class="rigth-text">生效日期：2022年7月4日</p>
      <p>
        【奇瑞官方商城】（【简称】或“我们”）重视并致力于保护你的隐私，我们通过制定【奇瑞官方商城】隐私政策（“本政策”）向你阐述了我们如何收集、使用和共享你的个人数据，请花些时间了解和熟悉我们在隐私保护方面的做法（可从下列标题访问），<strong>尤其是其中加粗的条款</strong>。如有任何疑问，请按下文“联系我们”提供的方式联系我们。
      </p>
      <p>
        本政策阐释了我们对你的个人数据的处理，通过我们的【网站或小程序】方式与我们互动和交流，都属于本政策的适用范围。
      </p>
      <p>
        <strong>请注意：我们还可能为你提供第三方的服务链接，我们建议你在与第三方互动之前先阅读他们的隐私政策，了解你的隐私权及个人数据将进行何种处理。</strong>
      </p>
      <table>
        <tr>
          <td>
            <p class="third-party-link"><a href="#_何为个人数据">何为个人数据</a></p>
          </td>
          <td>
            <p class="third-party-link"><a href="#_你享有的隐私权">你享有的隐私权</a></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="third-party-link">
              <a href="#_我们从你那里收集的个人数据">我们收集的你的个人数据</a>
            </p>
          </td>
          <td>
            <p class="third-party-link"><a href="#_我们对个人数据的使用">我们对个人数据的使用</a></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="third-party-link"><a href="#_我们对数据的委托处理">我们对数据的委托处理</a></p>
          </td>
          <td>
            <p class="third-party-link"><a href="#_我们对数据的共享">我们对数据的共享</a></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="third-party-link"><a href="#_关于你的个人数据的转让">关于你的个人数据的转让</a></p>
          </td>
          <td>
            <p class="third-party-link">
              <a href="#_共享、转让你的个人数据需事前获得同意的例外"
                >共享、转让你的个人数据需事前获得同意的例外</a
              >
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="third-party-link"><a href="#_关于你的个人数据的储存">关于你的个人数据的储存</a></p>
          </td>
          <td>
            <p class="third-party-link"><a href="#_我们对个人数据的保护">我们对个人数据的保护</a></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="third-party-link">
              <a href="#_国家/地区间的个人数据传输"
                >国家/地区间的个人数据传输</a
              >
            </p>
          </td>
          <td>
            <p class="third-party-link"><a href="#_未成年人的个人数据">未成年人的个人数据</a></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="third-party-link"><a href="#_COokie和其他技术">Cookies和其他技术</a></p>
          </td>
          <td>
            <p class="third-party-link"><a href="#_司法管辖区要求">司法管辖区的要求</a></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="third-party-link"><a href="#_欧盟居民适用条款">欧盟居民适用条款</a></p>
          </td>
          <td>
            <p class="third-party-link"><a href="#_美国加州居民使用条款">美国加州居民适用条款</a></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="third-party-link"><a href="#_隐私政策更新">隐私政策的更新</a></p>
          </td>
          <td>
            <p class="third-party-link"><a href="#_联系我们">联系我们</a></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="third-party-link"><a href="#_我们对你隐私的承诺">我们对你隐私的承诺</a></p>
          </td>
          <td></td>
        </tr>
      </table>
      <h1><a id="_何为个人数据"></a><a id="_Toc84858940"></a>何为个人数据</h1>
      <p>
        我们一直坚信并尊重基本隐私权，并认为这些基本权利不应因你生活的国家和地区而有所不同。<strong>正因为如此，我们将任何与已识别或可识别的个人相关的数据视为“个人数据”，而无论相关个人所居何处。</strong>这意味着，可用来直接识别你身份的数据（如你的姓名，身份证号）属于个人数据，另外，不能用来直接识别你的身份但可通过合理推断间接识别你身份的数据也是个人数据。经过技术处理后不能用于识别你的身份的数据，我们称其为“匿名化数据”，<strong
          >就本政策而言，匿名化数据被视为非个人数据。</strong
        >
      </p>
      <h1><a id="_你享有的隐私权"></a>你享有的隐私权</h1>
      <p>
        我们尊重你获知、访问、更正、传输、撤销和删除你的个人数据的权利。根据适用的数据隐私法律，我们将采取适当的技术手段向我们全球的每一位客户提供这些权利，如果你选择行使这些隐私权，你有权不受到区别对待，并且有权享有与你不行使隐私权时应获得的同等程度的服务质量。我们承诺，不会以获利为目的向任何一方出售你的数据。
      </p>
      <p>
        <strong
          >在你行使你的权利时，我们可以要求你提供身份证明进行验证，以确保我们对客户机密信息的保护。</strong
        >我们将在收到你的申请并验证你的身份后的七（7）天内回复处理意见或结果。
      </p>
      <p>
        在某些情况下，我们可能无法批准你的请求，例如，你要求删除你的交易数据但我们在法律上有义务保留该交易的记录以遵守适用的法律。如果你的请求会影响我们处于反欺诈和安全目的合法使用数据，我们也可能会拒绝你的请求，例如当你请求删除出于安全考虑而正在被调查的账号时。另外，如果你的隐私请求危机他人隐私、意义不大、不合理或极其不切实际，我们也可能会拒绝。
      </p>
      <p>
        对于你合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。
      </p>
      <p>你可以按照下文提供的方式来行使你的权利：</p>
      <ul>
        <li><strong>访问权</strong></li>
      </ul>
      <p>
        如果你想访问你的个人数据，包括但不限于账户信息、订单信息、车辆使用数据、我们共享你个人数据的接收方等信息，你可通过如下方式访问你的个人数据。
      </p>
      <p>
        【你可以通过登录【奇瑞官方商城】账户在如下功能访问你的相关个人数据：
      </p>
      <p>
        在“我的→个人信息”中查阅账户个人数据，可查看绑定手机号、昵称、性别、生日、城市、职业、个性签名
      </p>
      <p>
        在“我的→我的订单”中查阅购车订单、商品订单，包括订单类型、订单状态、订单时间、交易和消费记录（交易金额、订单号、地址电话）；
      </p>
      <p>
        在“我的→我的活动”中查阅已经参与过的活动信息，包括抽奖、参团、竞拍、竞猜；
      </p>
      <p>在“我的→我的卡券”中查阅你未使用、已过期、已使用的卡券信息。</p>
      <p>在“我的→现金红包”中查阅你待提现、已提现、已失效的现金红包。</p>
      <p>在“我的→我的奖品”中查阅你获得奖品信息。</p>
      <p>
        在“我的→收货地址”中可编辑你的收货地址，包括姓名、电话、地区、详细地址，最多可编辑10条收货地址信息。】
      </p>
      <p>
        如果无法通过上述方式访问你的个人数据，你可以随时通过奇瑞官方商城公众号中“在线客服”和我们取得联系，我们将在七（7）天内回复你处理意见或结果。
      </p>
      <ul>
        <li><strong>更正权</strong></li>
      </ul>
      <p>
        当你发现我们处理的关于你的个人数据有错误时，经对你的身份进行验证，在更正不影响信息的客观性和准确性的情况下，你有权对错误或不完整的信息作出更正或更新。
      </p>
      <p>
        【你可以通过登录【奇瑞官方商城小程序】账户在如下功能更正你的相关个人数据：
      </p>
      <p>
        更正个人数据：在“【我的→个人信息】”中更正你的头像、绑定手机号、昵称、性别、生日、城市、职业、个性签名。
      </p>
      <p>
        更正收货地址：在“【我的→收货地址】”中更正姓名、电话、地区、详细地址。】
      </p>
      <p>
        如果无法通过上述方式更正你的个人数据，你可以随时通过奇瑞官方商城公众号中“在线客服”和我们取得联系，我们将在七（7）天内回复你处理意见或结果。
      </p>
      <ul>
        <li><strong>删除权</strong></li>
      </ul>
      <p>
        如果你发现我们违反法律法规或违反与你的约定收集与他人分享你的个人数据，
        你有权要求我们进行删除。
      </p>
      <p>
        【你可通过【在线客服】提交相关申请。你也可以通过【我的-编辑资料】删除你的相关信息。】
      </p>
      <ul>
        <li><strong>撤销权</strong></li>
      </ul>
      <p>
        对于我们收集的个人数据的处理，你有权随时给予或收回你的授权同意。你可通过【在线客服】提交相关要求来改变你前期我们继续收集个人数据的范围的授权，也可以通过注销账户的方式，撤回对我们继续处理你个人数据的全部授权。如果你想注销你的【奇瑞官方商城】账户，你可以通过【在线客服】跟我们取得联系，要求注销您的账户。
      </p>
      <p>
        请你理解，每个功能需要一些基本的个人数据才能得以完成，<strong>当你撤回该功能项下个人数据的同意或授权后，我们无法继续为你提供对应的服务</strong>，也承诺将按照你的请求不再处理你相应的个人数据。但我们承诺，<strong
          >你撤回同意或授权的决定，不会影响此前基于你的授权而开展的个人数据处理。</strong
        >
      </p>
      <p>
        你有权选择是否接受我们、我们的关联企业及服务提供商通过电子邮件、短信、印刷材料等发送营销信息。你可随时通过这些信息中提供的退订机制退订这些信息，或根据以下“联系我们”所列的方式与我们联络来退订这些信息。
      </p>
      <ul>
        <li><strong>获得个人数据副本的权利</strong></li>
      </ul>
      <p>你有权获得你的个人数据副本，你可以通过【人工客服】获得。</p>
      <ul>
        <li><strong>响应你的请求的例外</strong></li>
      </ul>
      <p>在以下情形中，我们将无法响应你的请求：</p>
      <ul>
        <li>
          <ul>
            <li>与我们履行法律法规规定的义务相关的；</li>
            <li>与国家安全、国防安全直接相关的；</li>
            <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
            <li>与刑事侦查、起诉、审判和执行判决等直接相关的；</li>
            <li>有充分证据表明你存在主观恶意或滥用权利的；</li>
            <li>
              出于维护你或其他个人的生命、财产等重大合法权益但又很难得到你同意的；
            </li>
            <li>
              响应你的请求将导致你或其他个人、组织的合法权益受到严重损害的；
            </li>
            <li>涉及商业秘密的。</li>
          </ul>
        </li>
      </ul>
      <h1><a id="_我们从你那里收集的个人数据"></a>我们收集的你的个人数据</h1>
      <ul>
        <li><strong>我们从你那里收集的个人数据</strong></li>
      </ul>
      <p>
        我们相信我们能为你提供优秀的服务体验和良好的隐私保护。这意味着我们将努力只收集我们需要的个人数据。我们收集的个人数据的类别将取决于你与我们的互动方式（功能服务）。在以下场景（功能服务）中，我们将基于不同目的收集你的个人数据。我们不会以欺诈、诱骗、误导的方式收集你的个人数据。
      </p>
      <p>
        <strong>请注意</strong
        >：基于特定场景和目的，我们收集的数据中可能包含你的个人敏感信息，我们将会以<strong>加粗</strong>的形式标注出来，<strong>你有权选择不向我们提供该敏感信息的授权或同意</strong>，我们承诺你不授权的选择<strong>不会影响我们为你提供基础服务</strong>，<strong>仅会对部分个性化服务产生影响，</strong>我们会在下列场景中，将其标注出来。
      </p>
      <p>
        在你使用如下各项功能及服务时，我们将收集你的个人数据及其他与你有关的信息。
      </p>
      <p>
        <a id="_Hlk76882273"></a
        ><strong>注册账户</strong
        >：你可以在未注册账户、或未提供姓名及联系方式的模式下使用某些功能并体验某些服务，但有些服务则仅当你的注册后方能使用。在你注册账户的过程中，你需要向我们提供以下你的个人数据：【绑定手机号、昵称、性别、生日、城市、职业、个性签名】。
      </p>
      <p>
        <strong>支付功能：</strong
        >在订单支付中你可以使用微信支付。为完成订单支付，你需要绑定微信账户并选择付款方式。我们会将你的订单支付相关信息、订单安全相关设备信息及其他反洗钱法律要求的必要信息通过在网站或客户端中嵌入的微信软件工具开发包（软件工具开发包在本政策中简称“SDK”）等方式与微信公司共享。在你支付的过程中，我们会收集你的订单号以及订单金额以此来完成整个支付流程。如果未能获取到你的个人数据，我们将只提供基础的浏览功能，无法使用下单、支付功能。
      </p>
      <p>
        <strong>订购车辆</strong
        >：你可以在【购车】功能中订购奇瑞车辆，为实现此功能，你可能需向我们提供【购车商品名称、外饰、内饰】。你可在“我的订单”功能查阅你的车辆订购订单历史信息。如你不提供相关信息则无法通过【购车】功能进行订购。
      </p>
      <p>
        <strong>获取授权/同意的例外情形</strong
        >：请你谅解，在法律法规允许范围内，在如下情形中，我们可能会依法收集并使用你的个人数据而无需征得你的授权同意：-
      </p>
      <p>与国家安全、国防安全直接相关的；</p>
      <p>-与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>-与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
      <p>
        -出于维护你或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
      </p>
      <p>-所涉及的个人数据是你自行向社会公众公开的；</p>
      <p>-根据你的要求签订和履行合同所必需的；</p>
      <p>
        -从合法公开披露的信息中收集个人数据的，如合法的新闻报道、政府信息公开等渠道；
      </p>
      <p>
        -维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。
      </p>
      <ul>
        <li>
          <a id="_我们从其他来源收集的你的个人数据"></a
          ><strong>我们从其他来源收集的你的个人数据</strong>
        </li>
      </ul>
      <p>
        我们可能会从按照你的指示行事的其他个人、企业或第三方、协助我们提供产品和服务并在安全和防欺诈方面为我们提供协助的合作方以及其他合法来源收到你的相关个人数据。
      </p>
      <p>
        <strong>个人。</strong
        >我们可能会从其他个人那里收集关于你的数据，例如，如果这个人通过我们的商城中给你寄了一个产品，或者邀请你加入或享受某个我们提供的服务。
      </p>
      <p>
        <strong>第三方合作方。</strong
        >我们可能会向我们合作的第三方，如微信。我们可能从微信获取你授权共享的账户信息（头像、昵称），并在你同意本政策后将你的第三方账户与你的账户绑定，使你可以通过第三方账户直接登录并使用我们的产品与/或服务。
      </p>
      <p>
        出于研究和开发目的，我们可能会使用数据集，例如包含以下内容的数据集：可能会与可识别的个人联系在一起的图片、语音或其他数据。在获取此类数据集时，我们会遵守适用法律，包括数据集储存所在司法辖区的法律。<strong
          >在使用此类数据集进行研究和开发时，我们不会试图重新识别可能出现在其中的个人的身份信息。</strong
        >
      </p>
      <h1><a id="_我们对个人数据的使用"></a>我们对个人数据的使用</h1>
      <p>
        我们会出于以下目的使用个人数据：【为服务提供支持、处理你的交易、与你沟通、实施安全和防欺诈措施以及遵守法律】。我们也可能在经你同意的情况下将个人数据用于其他用途。
      </p>
      <ul>
        <li>
          <strong>我们仅在有合法的法律依据的情况下才使用你的个人数据。</strong
          >根据具体情况，我们可能需要征得你的同意或根据执行处理的必要性来履行与你订立的合同、保护你或其他人的切身利益或履行法律义务。我们也可能在我们认为符合我们或他人的合法利益且同时考虑到你的利益、权利和期望的情况下处理你的个人数据。
        </li>
        <li>
          <strong>为我们的服务提供支持。【</strong
          >我们会收集必要的个人数据来为我们的服务提供支持，收集的数据可能用于产品或服务的改进、用于审计或数据分析等内部目的或用于故障诊断等。】
        </li>
        <li>
          <strong>处理你的交易。【</strong
          >用于处理交易，我们需要收集你的姓名、购买内容和付款信息等数据。】
        </li>
        <li>
          <strong>与你沟通。【</strong
          >用于回复你的申请、就你的交易或账号与你联系我们的产品和服务、提供其他相关信息或请求你提供信息或反馈。有时，我们可能会使用个人数据向你发送重要通知，例如关于购买的信息以及条款、条件和政策的变更。<strong>由于这些信息对你至关重要，你不能拒绝接收这些重要通知。</strong>】
        </li>
        <li>
          <strong>安全和防欺诈。</strong
          >【旨在保护所有用户的利益，防止损失和预防欺诈，预先筛选或扫描上传内容中的潜在非法内容】
        </li>
        <li>
          <strong>用于提供个性化服务的个人数据。</strong
          >【用于提取你的浏览、搜索偏好、行为习惯、位置信息相关特征，以便向你提供更契合您需求的页面展示和推荐个性化内容】
        </li>
        <li>
          <strong>遵守法律。</strong
          >旨在遵守适用法律-例如履行税务或申报义务或遵守合法的政府要求。
        </li>
      </ul>
      <p>
        <strong
          >我们保留个人数据的时间仅限于满足收集目的所需的时间，并遵循本政策或我们的特定服务隐私声明中的相关规定或适用法律的相关要求。</strong
        >我们将根据本政策，在实现其中所述目的所必须的期间内保留你的个人数据。在评估保留期间，我们会先仔细查明是否有必要保留所收集的个人数据，如果需要保留，会努力以法律允许的最短时间来保留个人数据。
      </p>
      <p>我们会基于以下数据使用规则来使用你的个人数据：</p>
      <ol>
        <li>
          我们会根据本政策的约定并为实现我们的产品或服务功能对所收集的个人数据进行使用；
        </li>
        <li>
          为了保障服务的稳定性与安全性，我们会将你的个人数据用于身份验证、安全防范、诈骗监测、预防或禁止非法活动、降低风险、存档和备份用途；
        </li>
        <li>根据法律法规或监管要求向相关部门进行报告；</li>
        <li>
          在收集你的个人数据后，<strong>我们将通过技术手段对数据进行脱敏、去标识化处理，去标识化处理的信息将无法识别主体。</strong>请你了解并同意，在此情况下我们可以对你的个人数据进行综合统计、分析加工，以便为你提供更加准确、个性、流畅及便捷的服务，或帮助我们评估、改善涉及的服务及运营活动；
        </li>
        <li>
          请你注意，你在使用我们的产品或服务时所提供的所有个人数据，除非你删除或通过系统设置拒绝我们收集，否则将在你使用我们的产品或服务期间持续授权我们使用；
        </li>
        <li>
          我们会对我们的产品或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品或服务的整体使用趋势。但这些统计信息不包含你的任何身份识别信息；
        </li>
        <li>
          <strong
            >当我们要将你的个人数据用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认动作等形式再次征求你的同意。</strong
          >
        </li>
      </ol>
      <h1>
        <a id="_我们对数据的共享"></a
        ><a id="_我们对数据的委托处理"></a>我们对数据的委托处理
      </h1>
      <p>
        上述功能服务中，某些具体的功能或服务是由我们聘请的服务提供商来为你提供客户支持，我们仅会出于为你提供该功能支持这一目的向服务提供商委托收集你该功能项下所必要的个人数据。
      </p>
      <p>
        对我们委托处理个人信息的服务提供商，我们会与其签署严格的保密协定，要求他们按照我们的要求、本政策以及其他任何相关的保密和安全措施来处理个人信息。
      </p>
      <h1>我们对数据的共享</h1>
      <p>
        除非通过本政策或其他方式获得你的明确同意，我们不会与任何第三方分享你的个人数据。<strong>我们仅会出于合法、正当、必要、特定、明确的目的共享你的个人数据，并且只会共享提供服务所必要的个人数据</strong>。我们将在下述情况向第三方分享或提供你的个人数据：
      </p>
      <ul>
        <li>
          <strong>隐私政策所述目的。</strong
          >为向你提供服务或实现本政策“我们收集的你的个人数据”部分所述之目的将你的个人数据分享给：
        </li>
      </ul>
      <p>
        我们的第三方服务提供商或合作方，【如订单执行与产品安装、奇瑞汽车无线连接、信息技术及相关基础设施、客户服务、车辆维护或相关服务、电子邮件传送、审计、营销、语音命令处理以及其他类似服务的服务提供商。例如，为把商品送货给您，我们可能向物流公司分享你的姓名、联系方式和家庭地址信息。】
      </p>
      <p>
        未经我们同意，上述被分享方无权将共享的个人数据用于任何其他用途。<strong
          >对我们与之共享个人数据的公司、组织和个人，我们会与其签署严格的数据处理协议，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人数据，并且我们会要求合作方的数据安全能力和信息安全资质要满足相关法律法规的要求。</strong
        >
      </p>
      <ul>
        <li>
          <strong>法律法规或政府要求。</strong
          >根据法律法规、法院命令或其他法律程序、或有权政府机关的要求和倡导，向法院或政府机关提供你的个人数据。
        </li>
        <li>
          <strong>权利保护。</strong
          >因共享、转让个人数据发生安全事件且对个人数据主体合法权益造成损害的，我们会承担相应的责任；
        </li>
        <li>
          <strong>合并、收购、资产出售或融资。</strong
          >为合并、收购或资产出售等交易的需要，我们可能会将你的个人数据进行转让。<strong>在转移你的个人数据前，我们会给予你适当通知，并确保你的个人数据在转让后得到与本政策相当的保护。</strong>出于交易或融资目的，我们还可能因合作方、潜在买方或其他第三方的合理商业需求（如尽职调查），在合法、正当、必要范围内向该第三方或第三方的审计机构、律师事务所、顾问等主体分享你的个人数据。<strong
            >但是，若数据转移后，个人数据使用目的发生变更时，会重新取得你的明示同意。</strong
          >
        </li>
        <li>
          <strong>用户授权。</strong
          >根据你的授权分享给你选择的第三方服务提供商、你参与的促销活动的第三方赞助商以及你授权的社交媒体服务提供商等，【如我们根据你的要求将相关内容分享给微信时，会向微信提供你的用户名和相关的分享内容】
        </li>
        <li>
          <strong>公开的个人数据。</strong
          >我们可能会将你公开的个人数据与第三方合作方分享,
          以便为互联网用户提供更加便利的信息服务。你公开的个人数据，意味着你同意我们在法律允许的范围内使用该类信息，包括在对此类信息进行合理的去标志化或脱敏化等处理后分享给第三方合作方。我们会尽力采取技术手段保护你的个人数据不被泄露，但<strong
            >仍提请你注意不要上传并公开有关你的较为敏感的或你不希望我们向第三方分享的信息；</strong
          >
        </li>
        <li>
          <strong>与第三方合作提供的服务。</strong
          >在与第三方开展合作业务、共同向你提供服务过程中，我们可能将你的个人数据根据项目具体情况分享给第三方。我们可能会在你使用相关服务前<strong>通过弹框或其他方式</strong>向你提示个人数据分享的具体情况，并征求你的同意；也有可能由第三方直接向你收集，详情请注意第三方的隐私政策。
        </li>
        <li>
          <strong>研究新项目和新服务。</strong
          >为了为你提供更优质的服务，我们可能与第三方合作方进行潜在业务合作项目的探索和推进，并可能会将你的部分个人数据<strong>经过匿名化等适当的处理</strong>分享给潜在业务合作方。此类数据的分享一般仅限于合作项目立项前期分析、测试及规划、项目业务化推广的业务场景展示、大数据分析的目的；
        </li>
        <li>
          <strong>个人数据的披露。</strong
          >在有合法依据的情况下，如果我们确定披露对于执行我们的条款和条件或保护我们的运营或用户是合理必要的，或者在合并、收购、资产出售或融资过程中是合理必要的，我们也可能会披露关于你的信息。<strong
            >确有披露必要时，我们会告知你公开披露的目的、披露的信息类型、涉及的个人敏感信息种类，并征得你的明确同意，且采取符合业界标准的安全防护措施的前提下，才会公开披露你的个人数据。</strong
          >
        </li>
        <li>
          <strong>其他。</strong
          >我们可能会按照你的指示或在你同意的情况下与其他人共享你的个人数据，例如当我们与你的运营商共享信息以激活的账号时。
        </li>
      </ul>
      <p>
        为了更好地向你提供服务，我们内嵌了第三方SDK，这些第三方SDK可能会收集你的个人数据，以配合我们向你提供更全面的服务。我们将尽可能控制并保护你的个人数据的收集。请你注意，如果你拒绝将你的个人数据共享给特定第三方，你可能无法享受我们提供的部分服务。
      </p>
      <p>关于我们内嵌第三方SDK的具体信息，详见《第三方合作清单》。</p>
      <h1><a id="_关于你的个人数据的转让"></a>关于你的个人数据的转让</h1>
      <p>我们不会将你的个人数据转让给任何公司、组织和个人，但以下情况除外：</p>
      <ul>
        <li>
          <strong>在按照你的指示或者获得你明确同意的情况下转让</strong
          >：按照你的指示或获得你的明确同意后，我们会向其他方转让你的个人数据；
        </li>
        <li>
          在<strong>涉及合并、收购、资产转让或类似的交易</strong>时，如涉及到你的个人数据转让，<strong>在转移前，我们会给予你适当通知，并确保你的个人数据在转让后得到与本政策相当的保护。</strong>我们会要求新的持有你信息的公司、组织继续受本政策的约束，否则，我们将要求该公司、组织重新向你征求授权同意。
        </li>
      </ul>
      <h1>
        <a id="_共享、转让你的个人数据需事前获得同意的例外"></a
        >共享、转让你的个人数据需事前获得同意的例外
      </h1>
      <p>
        以下情形中，我们共享、转让、公开披露你的个人数据不必事先征得你的授权同意：
      </p>
      <ol>
        <li>与个人数据控制者履行法律法规规定的义务相关的；</li>
        <li>与国家安全、国防安全直接相关的；</li>
        <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
        <li>与刑事侦查、起诉、审判和判决执行等直接相关的；</li>
        <li>
          出于维护你或其他个人的生命、财产等重大合法权益但又很难得到你的授权同意的；
        </li>
        <li>你自行向社会公众公开的个人数据；</li>
        <li>
          从合法公开披露的信息中收集你的个人数据，如合法的新闻报道、政府信息公开等渠道。
        </li>
      </ol>
      <h1><a id="_关于你的个人数据的储存"></a>关于你的个人数据的储存</h1>
      <p>
        无论你在何处使用我们的产品，我们都会将你的个人数据存储在位于<strong>中国境内的【阿里云服务器】</strong>上，该等用户信息通常不会被跨境传输至中国境外。
      </p>
      <p>
        我们仅在为你提供相关服务之目的所必需的期限内和法律法规及监管规定的时限内留存你的个人数据。根据《汽车销售管理办法》和《互联网交互式服务安全管理要求》的规定，你注销账户后，我们将根据法律法规或监管规定，对你的汽车销售、用户等信息档案保存10年；其它产品的销售、用户等信息保存5年；对你的注册信息及历史变更记录进行永久保存。上述存储期限届满后，我们将删除你的个人身份信息和交易信息。
      </p>
      <h1><a id="_我们对个人数据的保护"></a>我们对个人数据的保护</h1>
      <p>
        我们相信良好的隐私依赖于高度的安全性。我们使用管理型、技术性和物理性保护措施来保护你的个人数据，同时将个人数据的性质、数据的处理以及面临的威胁纳入考虑。我们一直在持续改进这些保护措施，以确保你的个人数据始终安全。
      </p>
      <p>
        我们已使用符合业界标准的安全防护措施保护你提供的个人数据，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。
      </p>
      <ul>
        <li>
          我们已采取所有适当的组织、管理及技术措施，努力保护你提供的个人数据在我们内部机构的安全。我们会采取一切合理可行的措施，确保未收集无关的个人数据。我们只会在达成本政策所述目的所需的期限内保留你的个人数据，除非需要延长保留期或受到法律的允许。
        </li>
        <li>
          如我们停止运营相关系统，我们将及时停止通过该系统收集你个人数据的活动，将停止运营的通知告知你，并对所持有的你的个人数据进行删除或匿名化处理（法律另有规定除外）。
        </li>
        <li>
          采取了内部管理制度和技术保障措施等多方面的保护方式以保护你的个人数据，具体而言包括但不限于：
        </li>
      </ul>
      <p>
        在制度方面，我们制定了相关信息安全制度，对于超期储存的个人数据，我们将删除你的个人数据。
      </p>
      <p>
        在内部管理方面，我们设立专职的信息安全人员负责信息安全体系建设，范围涵盖了网络安全、漏洞管理、威胁发现以及安全事件处理流程等。
      </p>
      <p>
        在技术方面，我们在实践中使用侵入侦查/保护系统、网络防火墙、防病毒工具及防垃圾邮件工具等安全工具（如TDA、PA/CP/FT、WAF等），并对系统实施网络边界监控和保护措施。我们的系统使用
        HTTPS或者TLS等方式加密连接，以确保你的数据在传输过程中的安全。
      </p>
      <p>
        在定期安全审计上，根据流程我们将进行定期的安全审计，即每开发一个版本我们都要进行安全审计后才能进行上架发行。
      </p>
      <p>
        在定期合规审计上，我们应当委托数据安全审计专业机构定期对其处理个人信息遵守法律、行政法规的情况进行合规审计。
      </p>
      <p>
        互联网环境并非百分之百安全，我们无法保证系统及信息为100%安全。如果你认为我们的系统存在任何安全风险或漏洞，请根据以下“联系我们”部分所列的方式与我们联络。
      </p>
      <p>
        我们会制定网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照适用法律及法规向有关主管部门报告。
      </p>
      <p>
        在发生安全事件后，我们将按照法律法规的要求，及时向你告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、你可自主防范和降低风险的建议、对你的补救措施等。我们将及时将事件相关情况以短信通知、电话、邮件等你预留的联系方式告知你，难以逐一告知时我们会采取合理、有效的方式发布公告。
      </p>
      <h1><a id="_国家/地区间的个人数据传输"></a>国家/地区间的个人数据传输</h1>
      <p>
        由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，你的个人数据可能会被传输到世界各地的实体或被其访问（包括我们的关联公司），用于进行包括本政策中所述的、与你使用我们的产品和服务相关的处理活动。我们遵守在国家/地区间传输个人数据的相关适用法律，以确保你的数据在任何地方都受到保护。
      </p>
      <p>
        我们会在<strong>明确告知你境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类以及你向境外接收方行使本法规定权利的方式和程序</strong>等事项，并取得你的<strong>单独同意</strong>后，将你的个人信息实际被转移至中国境外。
      </p>
      <p>
        我们会根据相关法律法规的要求达成向境外提供个人信息的前提条件，包括完成国家网信部门组织的安全评估或按照国家网信部门的规定经专业机构进行个人信息保护认证或按照国家网信部门制定的标准合同与境外接收方订立合同，约定双方的权利和义务，或者相关法律法规的其他要求。同时，我们会采取合理措施确保境外接收方处理你个人信息的活动达到《个人信息保护法》规定的个人信息保护标准。
      </p>
      <h1><a id="_未成年人的个人数据"></a>未成年人的个人数据</h1>
      <p>
        我们的产品、网站和服务主要面向成人。除了适用法律要求外，我们不会在明知的情况下收集未成年人（根据当地法律适用规定）的个人数据。如未经其监护人同意，未成年人不得创建自己的用户账户，且勿向我们提供个人数据。
      </p>
      <p>
        对于经父母同意而收集未成年个人数据的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
      </p>
      <p>
        <strong
          >如果我们发现自己在未事先获得可证实的父母或监护人同意的情况下收集了未成年人的个人数据，则会设法尽快删除相关数据。</strong
        >
      </p>
      <p>
        如你为未成年人的父母或监护人，当你对你所监护的未成年人的信息处理存在疑问时，请通过下文中的联系方式联系我们。
      </p>
      <h1><a id="_COokie和其他技术"></a>Cookies和其他技术</h1>
      <p>我们可能通过Cookies或同类技术收集你的信息并用于以下用途：</p>
      <p>
        1、记住你的身份。例如：Cookies或同类技术有助于我们辨认你作为我们的注册用户的身份，或保存你向我们提供有关你的喜好或其他信息；
      </p>
      <p>
        2、分析你使用我们服务的情况。我们可利用Cookies或同类技术来了解你使用我们的服务进行什么活动、或哪些服务最受欢迎；
      </p>
      <p>
        3、广告优化。Cookies或同类技术有助于我们根据你的信息，向你提供与你相关的广告而非进行普遍的广告投放。
      </p>
      <p>
        我们为上述目的使用Cookies或同类技术的同时，可能将通过Cookies或同类技术收集的非个人身份信息汇总提供给广告商和其他伙伴，用于分析你和其他用户如何使用我们的服务。
      </p>
      <p>
        你可以通过浏览器或用户选择机制拒绝或管理Cookies或同类技术。但请你注意，如果你停用Cookies或同类技术，我们有可能无法为你提供最佳的服务体验，某些服务也可能无法正常使用。
      </p>
      <h1><a id="_司法管辖区要求"></a>司法管辖区要求</h1>
      <p>
        如果本政策的相关规定与特定的司法管辖区的法律、法规有冲突的，应以该等特定的司法管辖区的法律、法规的规定为准。
      </p>
      <h1><a id="_欧盟居民适用条款"></a>欧盟居民适用条款</h1>
      <p>
        如果你是欧盟居民，你应该清楚其他司法管辖区未必提供与欧盟相同的保障。但基于适用法律的要求下，我们在处理欧盟居民的个人数据时将会遵从欧盟隐私法下的直接义务。当欧盟隐私法适用时，你将有以下附加权利：(i)质疑我们基于合法利益依据的数据处理;(ii)
        就你同意进行自动化处理的个人数据要求数据迁移；及(iii)
        向你的本地数据保护机构提交投诉。
      </p>
      <h1><a id="_美国加州居民使用条款"></a>美国加州居民使用条款</h1>
      <p>
        如果你是美国加州居民，你可以向我们要求一份我们曾向某些第三方为了他们直接营销目的而提供了你可识别个人数据的名单。你可以在每个日历年提出一次要求。你需要在请求中证实你是加州居民及提供当时于加州的地址作回应。你可根据以下
        “联系我们”部分所列的方式提出书面请求。我们将于七（7）天内回复你的请求。
      </p>
      <h1><a id="_隐私政策更新"></a>隐私政策更新</h1>
      <p>
        <a id="_Hlk76883137"></a
        >如果我们决定更新我们的隐私政策，在新版隐私政策生效前，我们将以通知的方式公布更新的隐私政策，以便使你了解有哪些变化信息。
      </p>
      <p>
        未经你的明确同意，我们不会减损你在本政策下应享有的权利。如果本政策有变更，我们也将提供明显的通知，如通过弹出窗口，或直接向你发送电子邮件再次获得您的同意。
      </p>
      <h1><a id="_联系我们"></a>联系我们</h1>
      <p>
        我们设立了个人信息保护专职部门，将按照本政策保护你的个人信息。如你有关于网络信息安全的投诉和举报，或你对本政策、我们的隐私保护措施、你的信息的相关事宜有任何问题、意见或建议，请通过以下电话与我们的客服部门进行联系：
      </p>
      <p>联系电话：【400-883-8888】</p>
      <p>
        一般情况下，我们将在七（7）天内回复你处理结果。如果你对我们的回复不满意，<strong
          >特别是我们的个人数据处理行为损害了你的合法权益，且在您反馈后我们仍拒绝改进的，你还可以向网信、电信、公安及工商等监管部门进行投诉或举报或通过向被告所在地有管辖权的法院提起诉讼来寻求解决方案。</strong
        >
      </p>
      <h1><a id="_我们对你隐私的承诺"></a>我们对你隐私的承诺</h1>
      <p>
        为确保你个人数据的安全，我们向奇瑞全体员工传达了公司的隐私和安全准则，并在公司内部严格执行隐私保护措施。
      </p>
      <p>附件1：《第三方合作清单》</p>
      <h1>第三方合作清单</h1>
      <ol>
        <li>
          为保障【奇瑞官方商城】相关功能的实现与运行的安全稳定，我们可能会介入由第三方提供的软件开发包（SDK）实现相关目的。
        </li>
        <li>
          我们会对第三方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。
        </li>
        <li>
          我们在下表中对在【奇瑞官方商城】中接入的相关第三方SDK在目录中列明。
        </li>
      </ol>
      <el-table
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column prop="SDKName" label="第三方SDK名称"></el-table-column>
        <el-table-column prop="useScenarios" label="应用场景"></el-table-column>
        <el-table-column prop="collectionType" label="收集个人信息的类型"></el-table-column>
        <el-table-column prop="thirdPartySDKProvider" label="第三方SDK提供方"></el-table-column>
        <el-table-column prop="privacyLink" label="隐私政策链接">
          <template slot-scope="scope">
            <span v-html="scope.row.privacyLink" />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agreement',
  data() {
    return {
      tableData: [
        {
          id: '1',
          SDKName: '微信SDK',
          useScenarios: '微信授权登录，微信好友和微信朋友圈分享功能',
          collectionType: '设备信息，本机号码',
          thirdPartySDKProvider: '腾讯',
          privacyLink: '<a href="https://privacy.qq.com/" target="_blank">https://privacy.qq.com/</a>'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

strong {
  font-weight: bold;
  color: #000;
}

h1 {
  font-size: 18px;
  font-weight: 500;
}

ul {
  list-style-type: disc;
  padding-inline-start: 40px;
}

ol {
  list-style-type: decimal;
  padding-inline-start: 40px;
}

p {
  margin-block-start: 1em;
  // margin-block-end: 1em;
}

.agreement {
  font-size: 18px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 28px;

  .center-text {
    text-align: center;
  }

  .rigth-text {
    text-align: right;
  }

  .third-party-link {
    margin: 0;
    font-size: 14px;
    text-decoration: underline;

    &:nth-child(odd) {
      width: 300px;
    }
  }

  .panel {
    width: 70vw;
    padding: 40px;
    background: white;
    margin: 40px auto 60px;
  }
  .title {
    text-align: center;
    display: block;
    font-size: 22px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
    margin-bottom: 40px;
  }
  h1 {
    font-size: 18px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 25px;
    margin-top: 40px;
    margin-bottom: 25px;
  }
  p {
    font-size: 18px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 28px;
  }
  .footer {
    margin-top: 25px;
  }
}
.bar_content {
  a {
    font-size: 20px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 28px;
    margin-left: 10px;
    cursor: pointer;
  }
  img {
    transform: translateY(3px);
  }
  font-size: 20px;
  height: 52px;
  line-height: 52px;
}
</style>
